import DetailMixin from './detailMixin';
import overviewEditMixin from './overviewEditMixin';
import SocketMixin from './socketMixin';
import get from 'lodash/get';
import has from 'lodash/has';
export default {
  name: 'CoreDtwinDetailPublicMap',
  mixins: [SocketMixin, overviewEditMixin, DetailMixin],
  props: {},
  data: function () {
    return {
      showDescription: true
    };
  },
  computed: {
    headerBG() {
      if (get(this.dtwin, 'data.twinImageId')) {
        return `${process.env.VUE_APP_API_HOST}${process.env.VUE_APP_API_PATH}/upload/${this.dtwin.data.twinImageId}`;
      }
      return './img/transparent.png';
    },
    hasHeaderBG() {
      return get(this.dtwin, 'data.twinImageId');
    },
    parallaxHeight() {
      return 100;
    },
    isDescription() {
      return has(this.dtwin, 'data.description') && get(this.dtwin, 'data.description') !== '';
    }
  },
  watch: {},
  methods: {}
};